export default __webpack_public_path__ + "static/media/18.5321bdb3.jpg";